import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import './index.css';
import { Suspense, useEffect, useState } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import routes from './Routes/NavRoutes';
import { ThemeProvider } from './context/ThemeProvider';
import { ToastContainer } from 'react-toastify';
import { myFallback } from './libs/constant/Constant';
import { getLocalStorage, setLocalStorage } from './services/localSessionService';
import TypeContextProvider from './context/TypeContextProvider';
import { WindowThemeProvider } from './context/WindowFramProvier';
import ShowToast from './components/ShowToast';

const routers = createBrowserRouter(routes);

function App() {

  const [notification, setNotification] = useState({ title: '', body: '' });

  const getConfig = async () => {
      await fetch('/config.json',
        {
          headers : {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        })
        .then(function(response){
          return response.json();
        })
        .then(function(configJson) {
          setLocalStorage("config-json", JSON.stringify(configJson));
          Object.keys(configJson).forEach((el: any) => {
            setLocalStorage(el, configJson[el]);
          });
        });
  }

  useEffect(() => {
    const myRootDiv = document.getElementsByTagName('html');
    const Color_theme = getLocalStorage('Application_Colors');
    if (Color_theme) {
      myRootDiv[0]?.setAttribute('style', Color_theme);
    }
    getConfig();
  }, []);

  useEffect(() => {
    if (notification?.title) {
      ShowToast(notification?.title + ' - ' + notification.body, 'info', 'top-right');
    }
  }, [notification]);

  return (
    <Suspense fallback={myFallback}>
        <TypeContextProvider>
          <WindowThemeProvider>
            <ThemeProvider>
              <ToastContainer></ToastContainer>
              <RouterProvider router={routers}></RouterProvider>
            </ThemeProvider>
          </WindowThemeProvider>
        </TypeContextProvider>
    </Suspense>
  );
}

export default App;
